import $ from 'jquery';

const initAnchoNav = () => {
    const $anchorContent = $('.js-anchor-content');
    const $trigger = $('.js-sidebar-trigger');
    if ($anchorContent.length <= 0) return;

    const placedClass = 'placed';
    const fixedClass = 'fixed';
    let topPos = $anchorContent.offset().top; // section offset top
    let headerHeight; // main nav header height
    let $el; // sidebar element
    let elOffsetTop; // sidebar offset top
    let placed; // has class placed -> position absolute
    let fixed; // has class fixed -> position fixed
    let scrollTop; // window scroll top
    let screenWidth;
    let lastScrollTop = 0;

    // when scrolling up
    const onScrollUp = () => {
        const onPos = $el.css('top').replace('px', '') * 1 === 0;

        // minus by topPos because the section use relative position for IE11 on 768 above
        const topPosDecrease = screenWidth < 768 ? 0 : topPos;

        // when header not visible
        if (onPos && fixed) {
            $el.css({ top: scrollTop - topPosDecrease })
                .removeClass(fixedClass).addClass(placedClass);
        }

        if (placed && elOffsetTop >= scrollTop + headerHeight) {
            $el.css({ top: headerHeight })
                .removeClass(placedClass).addClass(fixedClass);
        }

        if (topPos > scrollTop + headerHeight) {
            $el.css({ top: '' })
                .removeClass(placedClass)
                .removeClass(fixedClass);

            $anchorContent.removeClass(fixedClass);
        }
    };

    // when scrolling down
    const onScrollDown = () => {
        const elCssTop = $el.css('top').replace('px', '') * 1;
        const linksBottom = $('.js-sidebar-anchor-links').outerHeight() + scrollTop;
        const anchorContentBottom = $anchorContent.outerHeight() + $anchorContent.offset().top;

        // minus by topPos because the section use relative position for IE11 on 768 above
        const topPosDecrease = screenWidth < 768 ? 0 : topPos;

        // set fixed if above viewport
        if (elOffsetTop < scrollTop && !placed && !fixed) {
            $el.addClass(fixedClass);
            $anchorContent.addClass(fixedClass);
        }

        // set placed if on stack
        if (fixed && elCssTop === headerHeight) {
            $el.css({ top: (scrollTop - topPosDecrease) + headerHeight })
                .removeClass(fixedClass).addClass(placedClass);
        }

        // set fixed if above view port but content bottom still hidden
        if (elOffsetTop <= scrollTop && linksBottom < anchorContentBottom) {
            $el.css({ top: '' })
                .removeClass(placedClass).addClass(fixedClass);
        }

        // set placed if content bottom === sidebar bottom
        if (!placed && linksBottom > anchorContentBottom && screenWidth >= 768) {
            $el.css({ top: scrollTop - topPosDecrease })
                .removeClass(fixedClass).addClass(placedClass);
        }
    };

    // on scroll
    const onscroll = () => {
        $(window).scroll(function () {
            headerHeight = $('.js-flex-fixed').outerHeight() || 0;
            $el = $('.js-sidebar-scroll-pos');
            placed = $el.hasClass(placedClass);
            fixed = $el.hasClass(fixedClass);
            elOffsetTop = $el.offset().top;
            scrollTop = Math.max($(this).scrollTop(), 0);

            if (scrollTop >= lastScrollTop) {
                onScrollDown();
            } else {
                onScrollUp();
            }
            lastScrollTop = scrollTop;
        });
    };

    // on resize
    const onResize = () => {
        $(window).on('resize', () => {
            // reset static size/anchor
            screenWidth = $(window).width();
            topPos = $anchorContent.offset().top;
            $('html, body').animate({ scrollTop: 0 }, 0);
        });
    };

    const iniGenerateAnchor = () => {
        const $titles = $anchorContent.find('.content h2');
        const $ul = $('.js-sidebar-anchor-links ul');
        $ul.html('');

        for (let i = 0; i <= $titles.length; i += 1) {
            const $title = $($titles[i]);

            if ($title.text()) {
                $title.attr({ id: `anchor-content-${i}` });
                $ul.append(`<li><a href="#anchor-content-${i}">${$title.text()}</a></li>`);
            }
        }

        $('.js-sidebar-anchor-links ul a').click(function (e) {
            e.preventDefault();
            let scrollTo = $($(this).attr('href')).offset().top;
            scrollTo = scrollTo < scrollTop ? scrollTo - headerHeight : scrollTo;
            $('html, body').animate({ scrollTop: scrollTo });

            // close sidebar if open on mobile
            $('body').removeClass('anchor-content-open');
        });

        // init toggle nav on mobile
        $trigger.click(() => {
            $('body').toggleClass('anchor-content-open');
        });
    };

    iniGenerateAnchor();

    // init scroll
    onResize();
    onscroll();
    $(window).trigger('resize').trigger('scroll');
};

// doc ready
$(() => {
    initAnchoNav();
});




// WEBPACK FOOTER //
// ./src/sections/anchor-content/s-anchor-content.js